export default function topLetters() {
    const topLetters = document.querySelector('.js-catch-copy-letters');
    const texts = topLetters.textContent;

    // 空に
    topLetters.textContent = '';

    const chars = texts.split('').map(char => {
        const span = document.createElement('span');
        span.className = 'char';
        span.style.display = 'inline-block';
        span.textContent = char;
        topLetters.insertAdjacentElement('beforeend', span);
        return span;
    });

    gsap.set([topLetters], {
        opacity: 1
    });

    // loadingComplete イベントを待ってからアニメーション開始
    gsap.from(chars, {
        opacity: 0,
        y: 30,
        duration: 0.5,
        stagger: 0.05,
        ease: 'power2.out',
        delay: 1
    });
}